/*
 * blend-carousel — "Inside the Blend" product carousel.
 * Motion = native CSS scroll-snap (one slide / viewport). JS only enhances:
 * arrows, dots, keyboard (←/→), optional autoplay, and clamp-vs-loop end behaviour.
 * Native touch swipe + momentum come free from the scroll container. Reduced-motion
 * → instant jumps + no autoplay. No dependencies. Degrades to a horizontal scroller
 * with no JS (controls are progressively enhanced).
 */
(function () {
  var roots = document.querySelectorAll('[data-blend]');
  if (!roots.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  roots.forEach(function (root) {
    var track = root.querySelector('[data-blend-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.blend__slide');
    var prevBtns = root.querySelectorAll('[data-blend-prev]');
    var nextBtns = root.querySelectorAll('[data-blend-next]');
    var dots = root.querySelectorAll('[data-blend-dot]');
    var n = slides.length;
    var loop = root.getAttribute('data-loop') === 'true';
    var state = { index: 0 };

    /* ---- entrance reveal ---- */
    if (reduce || !('IntersectionObserver' in window)) {
      root.classList.add('blend--in');
    } else {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) { if (e.isIntersecting) { root.classList.add('blend--in'); obs.disconnect(); } });
      }, { threshold: 0.12 });
      io.observe(root);
    }

    if (n < 2) return; // single slide → nothing to drive

    function clamp(i) { return loop ? (i % n + n) % n : Math.max(0, Math.min(n - 1, i)); }

    function goTo(i, smooth) {
      state.index = clamp(i);
      track.scrollTo({ left: state.index * track.clientWidth, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
      sync();
    }

    function readIndex() {
      if (!track.clientWidth) return state.index;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function sync() {
      dots.forEach(function (d, i) {
        if (i === state.index) { d.setAttribute('aria-current', 'true'); }
        else { d.removeAttribute('aria-current'); }
      });
      if (!loop) {
        prevBtns.forEach(function (b) { b.disabled = state.index <= 0; });
        nextBtns.forEach(function (b) { b.disabled = state.index >= n - 1; });
      }
    }

    /* ---- controls ---- */
    prevBtns.forEach(function (b) { b.addEventListener('click', function () { goTo(state.index - 1); stopAuto(); }); });
    nextBtns.forEach(function (b) { b.addEventListener('click', function () { goTo(state.index + 1); stopAuto(); }); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-index'), 10) || 0); stopAuto(); });
    });

    /* keyboard on the region */
    root.addEventListener('keydown', function (e) {
      var t = e.target.tagName;
      if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT') return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(state.index - 1); stopAuto(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(state.index + 1); stopAuto(); }
    });

    /* keep index in sync with native swipe / momentum scroll */
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = readIndex();
        if (i !== state.index) { state.index = i; sync(); }
      });
    }, { passive: true });

    /* realign on resize (slide width changed) */
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { track.scrollTo({ left: state.index * track.clientWidth, behavior: 'auto' }); }, 120);
    });

    /* ---- optional autoplay ---- */
    var timer = null;
    var speed = (parseFloat(root.getAttribute('data-autoplay-speed')) || 6) * 1000;
    var wantAuto = root.getAttribute('data-autoplay') === 'true' && !reduce;
    function tick() { var nx = state.index + 1; if (nx >= n) nx = 0; goTo(nx); }
    function startAuto() { if (wantAuto && !timer) timer = setInterval(tick, speed); }
    function stopAuto() { wantAuto = false; if (timer) { clearInterval(timer); timer = null; } } // any manual input ends autoplay for the session
    function pauseAuto() { if (timer) { clearInterval(timer); timer = null; } }
    function resumeAuto() { if (wantAuto && !timer) timer = setInterval(tick, speed); }

    if (wantAuto) {
      ['pointerenter', 'focusin', 'pointerdown', 'touchstart'].forEach(function (ev) { root.addEventListener(ev, pauseAuto, { passive: true }); });
      ['pointerleave', 'focusout'].forEach(function (ev) { root.addEventListener(ev, resumeAuto); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) pauseAuto(); else resumeAuto(); });
      startAuto();
    }

    sync();
  });
})();
